import {
    getData, errorHelper
} from '@/store/config/methodCsrf'

const initialState = () => ({
})

const state = initialState
 
const getters = {
}

const actions = {
    async getAdminMaster(_,path = 'faculties') {
        try {
            const response = await getData('admin',`/api/public/${path}`);
            return response.data
        } catch (err) {
            return errorHelper(err)
        }
    },
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}